import moment from "moment"
import { dateManipulateDay, diffDays, isCheckFormat, format, nowDate, correctionDate } from "./date"

export const isMinimumPlan = (plan: string | undefined): boolean => typeof plan !== "undefined" && plan === "minimum_plan"

export const isStandardPlan = (plan: string | undefined): boolean => typeof plan !== "undefined" && plan === "standard_plan"

export const isProfessionalPlan = (plan: string | undefined): boolean => typeof plan !== "undefined" && plan === "professional_plan"

export const mapAllowedDate = (targetDate: string, plan: string, created_at: string, isAllowToday = true): string => {
  if (
    (
      isCheckFormat(targetDate, 'YYYY-MM-DD')
      && moment(targetDate, 'YYYY-MM-DD').diff(correctionDate(nowDate()), 'day') < 0
    )
  ) {
    return targetDate
  }
  return dateManipulateDay(correctionDate(nowDate()), isAllowToday ? 0 : -1, 'YYYY-MM-DD')
}

export const mapAllowedDateForTimeline = (targetDate: string, plan: string, created_at: string): string => {
  if (
    (
      isCheckFormat(targetDate, 'YYYY-MM-DD')
      && moment(targetDate, 'YYYY-MM-DD').diff(nowDate(), 'day') < 0
    )
  ) {
    return targetDate
  }
  return dateManipulateDay(nowDate(), 0, 'YYYY-MM-DD')
}
